import { createSlice } from '@reduxjs/toolkit'
import { PageState } from './types'
import { PageContentService } from '../../services/pageContent/PageContentService'

const initialState: PageState = {
  isPageActive: true,
  isGetAllPagesLoading: false,
  isCreatePageLoading: false,
  isUpdatePageLoading: false,
  isDeletePageLoading: false,
  isGetPageDescriptionByIdLoading: false,
  isGetPageTitleByIdLoading: false,
  isGetPageStatusByIdLoading: false,
  pages: []
}

const slice = createSlice({
  name: 'pageContent',
  initialState,
  reducers: {
    togglePageActive: (state) => {
      state.isPageActive = !state.isPageActive
    },
    resetDetail: (state) => {
      if (state.pageDescription) {
        state.pageDescription.description = ''
      }
    },
    resetPageState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(PageContentService.getAllPagesAsyncThunk.pending, (state) => {
        state.isGetAllPagesLoading = true
      })
      .addCase(PageContentService.getAllPagesAsyncThunk.rejected, (state) => {
        state.isGetAllPagesLoading = false
      })
      .addCase(PageContentService.getAllPagesAsyncThunk.fulfilled, (state, action) => {
        state.isGetAllPagesLoading = false
        state.pages = action.payload.pages
      })
      .addCase(PageContentService.getPageTitleByIdAsyncThunk.pending, (state) => {
        state.isGetPageTitleByIdLoading = true
      })
      .addCase(PageContentService.getPageTitleByIdAsyncThunk.rejected, (state) => {
        state.isGetPageTitleByIdLoading = false
      })
      .addCase(PageContentService.getPageTitleByIdAsyncThunk.fulfilled, (state, action) => {
        state.isGetPageTitleByIdLoading = false
        state.pageTitle = action.payload.page
        state.pageTimestampDetail = action.payload.page
      })
      .addCase(PageContentService.getPageDescriptionByIdAsyncThunk.pending, (state) => {
        state.isGetPageDescriptionByIdLoading = true
      })
      .addCase(PageContentService.getPageDescriptionByIdAsyncThunk.rejected, (state) => {
        state.isGetPageDescriptionByIdLoading = false
      })
      .addCase(PageContentService.getPageDescriptionByIdAsyncThunk.fulfilled, (state, action) => {
        state.isGetPageDescriptionByIdLoading = false
        state.pageDescription = action.payload.page
        state.pageTimestampDetail = action.payload.page
      })
      .addCase(PageContentService.getPageStatusByIdAsyncThunk.pending, (state) => {
        state.isGetPageStatusByIdLoading = true
      })
      .addCase(PageContentService.getPageStatusByIdAsyncThunk.rejected, (state) => {
        state.isGetPageStatusByIdLoading = false
      })
      .addCase(PageContentService.getPageStatusByIdAsyncThunk.fulfilled, (state, action) => {
        state.isGetPageStatusByIdLoading = false
        state.isPageActive = action.payload.page.isActive
        state.pageTimestampDetail = action.payload.page
      })
      .addCase(PageContentService.createPageAsyncThunk.pending, (state) => {
        state.isCreatePageLoading = true
      })
      .addCase(PageContentService.createPageAsyncThunk.rejected, (state) => {
        state.isCreatePageLoading = false
      })
      .addCase(PageContentService.createPageAsyncThunk.fulfilled, (state) => {
        state.isCreatePageLoading = false
      })
      .addCase(PageContentService.updatePageAsyncThunk.pending, (state) => {
        state.isUpdatePageLoading = true
      })
      .addCase(PageContentService.updatePageAsyncThunk.rejected, (state) => {
        state.isUpdatePageLoading = false
      })
      .addCase(PageContentService.updatePageAsyncThunk.fulfilled, (state) => {
        state.isUpdatePageLoading = false
      })
      .addCase(PageContentService.deletePageAsyncThunk.pending, (state) => {
        state.isDeletePageLoading = true
      })
      .addCase(PageContentService.deletePageAsyncThunk.rejected, (state) => {
        state.isDeletePageLoading = false
      })
      .addCase(PageContentService.deletePageAsyncThunk.fulfilled, (state) => {
        state.isDeletePageLoading = false
      })
  }
})

export const { resetPageState, togglePageActive, resetDetail } = slice.actions
export default slice.reducer
